import langButton from "@/components/langButton";
function plugin(Vue) {
    if (plugin.installed) {
        return;
    }
    Vue.component("langButton", langButton);
}

export default plugin